import { SearchUsers } from "./ui";

export default SearchUsers;
